<template>
  <action-dispatcher
    :parameters="$route.query.s"
    action="search/getAll"
    class="view-search py-5 container-fluid"
  >
    <h3 class="mb-4">Buscando por: {{ $route.query.s }}</h3>

    <div class="row" v-if="news.length > 0">
      <div class="col-12 py-3">
        <b-button visible class="my-button" v-b-toggle:collapse-4
          >Notícias
          <span class="when-open px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-baixo.png"
              alt="seta"
          /></span>
          <span class="when-closed px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-cima.png"
              alt="seta"/></span
        ></b-button>
      </div>
      <b-collapse id="collapse-4" visible class="row">
        <div
          v-for="(newss, i) in news"
          :key="i"
          class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"
        >
          <news-search :results="newss" class="flex-fill" />
        </div>
      </b-collapse>
    </div>

    <div class="row" v-if="courses.length > 0">
      <div class="col-12 py-3">
        <b-button class="my-button" v-b-toggle.collapse-2
          >Trilhas
          <span class="when-open px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-baixo.png"
              alt="seta"
          /></span>
          <span class="when-closed px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-cima.png"
              alt="seta"
          /></span>
        </b-button>
      </div>
      <b-collapse visible id="collapse-2" class="row">
        <div
          v-for="(course, i) in courses"
          :key="i"
          class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"
        >
          <course-search :results="course" class="flex-fill" />
        </div>
      </b-collapse>
    </div>
    <div class="row" v-if="lessons.length > 0">
      <div class="col-12 py-3">
        <b-button class="my-button" v-b-toggle.collapse-lessons
          >Aulas
          <span class="when-open px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-baixo.png"
              alt="seta"
          /></span>
          <span class="when-closed px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-cima.png"
              alt="seta"
          /></span>
        </b-button>
      </div>
      <b-collapse visible id="collapse-lessons" class="row">
        <div
          v-for="(lesson, i) in lessons"
          :key="i"
          class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"
        >
          <lesson-search :results="lesson" class="flex-fill" />
        </div>
      </b-collapse>
    </div>

    <div class="row" v-if="products.length > 0">
      <div class="col-12 py-3">
        <b-button class="my-button" v-b-toggle.collapse-3
          >Clube de Benefícios
          <span class="when-open px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-baixo.png"
              alt="seta"
          /></span>
          <span class="when-closed px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-cima.png"
              alt="seta"
          /></span>
        </b-button>
      </div>
      <b-collapse visible id="collapse-3" class="row">
        <div
          v-for="(product, i) in products"
          :key="i"
          class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"
        >
          <product-link :product="product" class="flex-fill" />
        </div>
      </b-collapse>
    </div>

    <div class="row" v-if="blog.length > 0">
      <div class="col-12 py-3">
        <b-button class="my-button" v-b-toggle.collapse-1
          >Bolsas e oportunidades
          <span class="when-open px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-baixo.png"
              alt="seta"
          /></span>
          <span class="when-closed px-1"
            ><img
              width="14"
              height="14"
              src="@/assets/images/seta-cima.png"
              alt="seta"
          /></span>
        </b-button>
      </div>
      <b-collapse visible id="collapse-1" class="row">
        <div
          v-for="(post, i) in blog"
          :key="i"
          class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"
        >
          <blog-search :results="post" class="flex-fill" />
        </div>
      </b-collapse>
    </div>

    <em
      v-if="
        blog.length <= 0 &&
          lessons.length <= 0 &&
          courses.length <= 0 &&
          news.length <= 0 &&
          products <= 0
      "
      class="text-secondary d-block small mb-5 pb-5"
      >Nenhum resultado</em
    >
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import ActionDispatcher from "../components/ActionDispatcher.vue";

import ProductLink from "../components/marketplace/ProductLink.vue";
import BlogSearch from "../components/search/BlogSearch.vue";
import CourseSearch from "../components/search/CourseSearch.vue";
import LessonSearch from "../components/search/LessonSearch.vue";
import NewsSearch from "../components/search/NewsSearch.vue";
export default {
  components: {
    ActionDispatcher,
    BlogSearch,
    NewsSearch,
    ProductLink,
    CourseSearch,
    LessonSearch
  },
  computed: {
    ...mapState("search", ["blog", "courses", "news", "products", "lessons"])
  }
};
</script>
<style lang="scss" scoped>
.view-search {
  .my-button {
    background: transparent;
    border: none;
    font-size: 22px;
  }
  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }
  .icon-circle-up:before {
    content: "\ea41";
  }
}
</style>
